import styled from 'styled-components';
import {MultiSelect as MantineMultiSelect} from '@mantine/core';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};

  .input {
    height: 100%;
    outline: none;
    border-radius: 3px;

    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;

    .mantine-MultiSelect-searchInput::placeholder {
      color: rgba(0, 0, 0, 0.6);
      font-weight: 600;
      font-size: 14px;
    }
  }

  .mantine-MultiSelect-pillsList {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
`;

export const StyledMultiSelect = styled(MantineMultiSelect).attrs((props) => ({
  styles: {
    root: {width: '100%'},
    wrapper: {minHeight: 30},
    rightSection: {display: 'none'},
    selected: {
      backgroundColor: props.theme.colors.primaryLight,
      color: props.theme.colors.primary,
    },
    values: {width: '100%'},
    options: {
      backgroundColor: props.theme.colors.card,
      color: props.theme.colors.text,
    },
    input: {
      outline: 'none',
      color: 'black',
      fontWeight: 600,
      padding: 10,
      backgroundColor: props.theme.colors.background,
      borderRadius: 4,
      border: `1px solid ${props.theme.colors.inputBorder}`,
    },
  },
  classNames: {input: 'input'},
}))``;
